const DialogsButtons = ({
  Btn1,
  Btn2,
  color,
  onClose,
  onClick,
  disable,
  isSubmit,
}) => {
  return (
    <div className=" w-full text-white flex items-center justify-around">
      <button
        onClick={onClose}
        className="w-[160px] h-[50px] rounded-[50px] bg-black cursor-pointer"
      >
        {Btn1}
      </button>
      <button
        type={isSubmit ? "submit" : "button"}
        disabled={disable}
        onClick={onClick}
        className={`w-[160px] h-[50px] rounded-[50px] bg-${color} cursor-pointer disabled:bg-gray-300 disabled:cursor-not-allowed`}
      >
        {Btn2}
      </button>
    </div>
  );
};

export default DialogsButtons;
